import { Skeleton } from '@/components/ui';

/** Loading placeholder matching the binary-question lobby card (ARC-82 §4). */
export function BinaryQuestionCardSkeleton() {
  return (
    <div className="bg-surface border-[1.5px] border-stroke-soft rounded-[12px] overflow-hidden">
      <div className="flex flex-col gap-2 px-5 pt-[18px]">
        <div className="flex items-center gap-1.5">
          <Skeleton className="size-[30px] rounded-full flex-shrink-0" />
          <Skeleton className="h-4 w-2/5 rounded" />
        </div>
        <Skeleton className="h-5 w-4/5 rounded" />
      </div>
      <div className="flex flex-col gap-2 px-5 pt-3">
        {[1, 2].map((i) => (
          <div key={i} className="flex items-center gap-6 h-10">
            <Skeleton className="h-3.5 flex-1 rounded" />
            <div className="flex items-center gap-1.5">
              <Skeleton className="h-3.5 w-10 rounded" />
              <Skeleton className="h-8 w-[74px] rounded-pill" />
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between px-5 py-2.5 mt-2 border-t border-stroke-soft">
        <Skeleton className="h-3.5 w-24 rounded" />
        <Skeleton className="h-4 w-16 rounded" />
      </div>
    </div>
  );
}
